import { useEffect, useState } from 'react';
import Access from "../Components/Access";
import Navbar from "../Components/Navbar";
import NavbarAdmin from "../Components/NavbarAdmin";
import { rescueHtml } from '../Components/Tools';
import axios from 'axios';
import qs from 'qs';
import {NotificationManager} from 'react-notifications';
import * as XLSX from 'xlsx';


const Nomenclature = (props) =>
{
    const [aff, setAff] = useState(false);
    const [liste, setListe] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [boolID, setBoolID] = useState(true);
    const [boolRang, setBoolRang] = useState(false);
    const [boolNomen, setBoolNomen] = useState(false);
    const [boolAnnee, setBoolAnnee] = useState(false);
    const [boolCompte, setBoolCompte] = useState(false);
    const [boolNom, setBoolNom] = useState(false);
    const [boolFctinv, setBoolFctinv] = useState(false);
    const [boolRecdep, setBoolRecdep] = useState(false);
    const [boolOld, setBoolOld] = useState(false);
    const [boolIndentation, setBoolIndentation] = useState(false);
    const [boolCalcul, setBoolCalcul] = useState(false);
    const [filterMatricule, setFilterMatricule] = useState('');
    const [filterAnnee, setFilterAnnee] = useState('');
    const [filterNomen, setFilterNomen] = useState('');
    const [filterCompte, setFilterCompte] = useState('');
    const [filterNom, setFilterNom] = useState('');
    const [filterFctinv, setFilterFctinv] = useState('');
    const [filterRecdep, setFilterRecdep] = useState('');
    const [filterRang, setFilterRang] = useState('');
    const [filterRangOp, setFilterRangOp] = useState('eq');
    const [showImportModal, setShowImportModal] = useState(false);
    const [importAnnee, setImportAnnee] = useState('');
    const [importNomen, setImportNomen] = useState('');
    const [importFile, setImportFile] = useState(null);
    const [importDragOver, setImportDragOver] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const heightObject = window.innerHeight / 1.9;

    const purple = '#6571FE';
    const blue = '#069BD3';
    const green = '#59B44A';

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!props.user) {
            props.getUser();
        } else {
            getNomenclature();
        }
    }, [props.user]);

    async function getNomenclature(overrides = {})
    {
        setIsLoading(true);

        const f = {
            matricule: filterMatricule,
            annee:     filterAnnee,
            nomen:     filterNomen,
            compte:    filterCompte,
            nom:       filterNom,
            fctinv:    filterFctinv,
            recdep:    filterRecdep,
            ...overrides
        };

        const params = {'getNomenclature': true};
        if (f.matricule !== '') params.matricule = f.matricule;
        if (f.annee     !== '') params.annee     = f.annee;
        if (f.nomen     !== '') params.nomen     = f.nomen;
        if (f.compte    !== '') params.compte    = f.compte;
        if (f.nom       !== '') params.nom       = f.nom;
        if (f.fctinv    !== '') params.fctinv    = f.fctinv;
        if (f.recdep    !== '') params.recdep    = f.recdep;

        axios.post("https://app-slfinance.fr/api/nomenclature.php", qs.stringify(params))
        .then((res) => {
            var tmp = [];
            // cast le item.rang et l'id en int/float pour éviter les problèmes de tri
            for (const item of res.data) {
                item.rang = parseFloat(item.rang);
                item.id = parseInt(item.id, 10);
                tmp.push(item);
            }
            setListe(tmp);
            setIsLoading(false);
        })
        .catch((err) => {
            console.warn(err);
            setIsLoading(false);
        });
    }

    const handleImport = async () => {
        if (!importFile) {
            NotificationManager.warning('Veuillez sélectionner un fichier XLSX.');
            return;
        }
        const formData = new FormData();
        formData.append('importNomenclature', true);
        formData.append('file', importFile);
        try {
            const response = await axios.post('https://app-slfinance.fr/api/nomenclature.php', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (response.data.status === 1) {
                NotificationManager.success(response.data.status_message || 'Import réussi');
                setShowImportModal(false);
                setImportFile(null);
                getNomenclature();
            } else {
                NotificationManager.error(response.data.status_message || 'Erreur lors de l\'import');
            }
        } catch (err) {
            console.warn(err);
            NotificationManager.error('Erreur lors de l\'import');
        }
    };

    const getListeFiltered = () => {
        return liste.filter(item => {
            const matriculeMatch = filterMatricule === '' || (item.matricule || '').toLowerCase().includes(filterMatricule.toLowerCase());
            const anneeMatch    = filterAnnee === ''    || (item.annee || '').toString() === filterAnnee;
            const nomenMatch    = filterNomen === ''    || (item.nomen || '').toLowerCase().includes(filterNomen.toLowerCase());
            const compteMatch   = filterCompte === ''   || (item.compte || '').toLowerCase().includes(filterCompte.toLowerCase());
            const nomMatch      = filterNom === ''      || (item.nom || '').toLowerCase().includes(filterNom.toLowerCase());
            const fctinvMatch   = filterFctinv === ''   || (item.fctinv || '') === filterFctinv;
            const recdepMatch   = filterRecdep === ''   || (item.recdep || '') === filterRecdep;
            const rangMatch     = filterRang === '' || (() => {
                const val = parseFloat(item.rang);
                const target = parseFloat(filterRang);
                if (isNaN(val) || isNaN(target)) return false;
                if (filterRangOp === 'gt')  return val > target;
                if (filterRangOp === 'gte') return val >= target;
                if (filterRangOp === 'lt')  return val < target;
                return val === target;
            })();
            return matriculeMatch && anneeMatch && nomenMatch && compteMatch && nomMatch && fctinvMatch && recdepMatch && rangMatch;
        });
    };

    const downloadCSV = () => {
        const filteredData = getListeFiltered();
        const headers = ['ID', 'Rang', 'Nomen', 'Année', 'Matricule', 'Compte', 'Nom', 'Fct/Inv', 'Rec/Dep', 'Old', 'Indentation', 'Calcul', 'Display', 'Retro only'];

        let csvContent = headers.join(',') + '\n';
        filteredData.forEach(item => {
            const row = [
                item.id,
                item.rang,
                item.nomen,
                item.annee,
                item.matricule,
                item.compte,
                `"${(item.nom || '').replace(/"/g, '""')}"`,
                item.fctinv,
                item.recdep,
                item.old,
                item.indentation,
                item.calcul,
                item.display,
                item.retro_only,
            ];
            csvContent += row.join(',') + '\n';
        });

        let filename = 'nomenclature_' + new Date().toISOString().split('T')[0] + '.csv';
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        NotificationManager.success('CSV téléchargé');
    };

    const downloadXLSX = () => {
        const filteredData = getListeFiltered();
        const headers = ['ID (à supprimer si on ajoute une nouvelle année)', 'Rang', 'Nomen', 'Année', 'Matricule', 'Compte', 'Nom', 'Fct/Inv', 'Rec/Dep', 'Old', 'Indentation', 'Calcul', 'Display', 'Retro only'];

        const sheetData = [
            headers,
            ...filteredData.map(item => [
                item.id,
                item.rang,
                item.nomen,
                item.annee,
                item.matricule,
                item.compte,
                rescueHtml(item.nom),
                item.fctinv,
                item.recdep,
                item.old,
                item.indentation,
                item.calcul,
                item.display,
                item.retro_only,
            ])
        ];

        const filterParts = [filterAnnee, filterNomen, filterMatricule, filterCompte, filterNom, filterFctinv, filterRecdep, filterRang ? (filterRangOp === 'eq' ? '' : filterRangOp) + filterRang : ''].filter(v => v !== '');
        let filename = 'nomenclature' + (filterParts.length > 0 ? '_' + filterParts.join('_') : '_' + new Date().toISOString().split('T')[0]) + '.xlsx';
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Nomenclature');
        XLSX.writeFile(workbook, filename);
        NotificationManager.success('XLSX téléchargé');
    };

    const sortBy = (field, bool, setBool) => {
        const sorted = [...liste].sort((a, b) => {
            const valA = a[field] !== null && a[field] !== undefined ? a[field] : '';
            const valB = b[field] !== null && b[field] !== undefined ? b[field] : '';
            if (typeof valA === 'number' && typeof valB === 'number') {
                return bool ? valB - valA : valA - valB;
            }
            const strA = valA.toString().toUpperCase();
            const strB = valB.toString().toUpperCase();
            if (strA < strB) return bool ? 1 : -1;
            if (strA > strB) return bool ? -1 : 1;
            return 0;
        });
        setListe(sorted);
        setBool(!bool);
        setAff(a => !a);
    };

    const inputStyle = (flex, minWidth, bold = false) => ({
        flex,
        padding: isMobile ? '10px 6px' : '10px 8px',
        minHeight: isMobile ? '45px' : '50px',
        minWidth,
        border: 'none',
        borderLeft: '1px solid #ddd',
        outline: 'none',
        fontSize: isMobile ? '10px' : '13px',
        backgroundColor: 'transparent',
        transition: 'all 0.2s',
        boxSizing: 'border-box',
        color: '#333',
        fontWeight: bold ? 'bold' : 'normal',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    });

    const headerBtnStyle = (flex, minWidth) => ({
        flex,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        padding: isMobile ? '10px 4px' : '12px 8px',
        fontSize: isMobile ? '11px' : '13px',
        fontWeight: 'bold',
        minHeight: isMobile ? '40px' : '45px',
        minWidth,
        backgroundColor: blue,
        cursor: 'pointer',
        transition: 'all 0.2s',
    });

	return (
        <>
        <Access needConnection={true} type_user={[1]}>
            <Navbar />
            <NavbarAdmin />

            {/* Titre + export */}
            <div style={{display: 'flex', margin: 25}}>
                <div style={{display: 'flex', flex: 1, alignItems: 'center'}}>
                    <p>Gestion \</p>
                    <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Nomenclature</p>
                </div>
                <div style={{flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 10}}>
                    {/* <button onClick={downloadCSV} style={{padding: '8px 16px', backgroundColor: purple, color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: isMobile ? '11px' : '16px'}}>
                        📥 CSV
                    </button> */}
                    <button onClick={downloadXLSX} style={{padding: '8px 16px', backgroundColor: purple, color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: isMobile ? '11px' : '16px'}}>
                        📥 Télécharger au format XLSX
                    </button>
                    <button onClick={() => setShowImportModal(true)} style={{padding: '8px 10px', backgroundColor: green, color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: isMobile ? '11px' : '16px'}}>
                        + Importer
                    </button>
                </div>
            </div>

            {/* Filtres */}
            <div className='shadow-md rounded-md' style={{margin: isMobile ? 10 : 50, padding: 20, backgroundColor: '#f9f9f9', marginBottom: 20}}>
                <h3 style={{marginTop: 0, marginBottom: 15}}>Filtres</h3>
                <div style={{display: 'flex', flexDirection: 'column', gap: 15}}>
                    <div style={{display: 'flex', flexWrap: 'wrap', gap: 15}}>
                        <div style={{flex: isMobile ? '0 0 100%' : 1, minWidth: '150px'}}>
                            <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Matricule</label>
                            <input type="text" placeholder="Filtrer par matricule..." defaultValue={filterMatricule}
                                onBlur={(e) => { setFilterMatricule(e.target.value); if (e.target.value === filterMatricule) return; getNomenclature({matricule: e.target.value}); }}
                                style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}} />
                        </div>
                        <div style={{flex: isMobile ? '0 0 100%' : '0 0 120px', minWidth: '100px'}}>
                            <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Année</label>
                            <input type="text" placeholder="Ex: 2014" defaultValue={filterAnnee}
                                onBlur={(e) => { setFilterAnnee(e.target.value); if (e.target.value === filterAnnee) return; getNomenclature({annee: e.target.value}); }}
                                style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}} />
                        </div>
                        <div style={{flex: isMobile ? '0 0 100%' : '0 0 120px', minWidth: '100px'}}>
                            <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Nomen</label>
                            <input type="text" placeholder="Ex: M14" defaultValue={filterNomen}
                                onBlur={(e) => { setFilterNomen(e.target.value); if (e.target.value === filterNomen) return; getNomenclature({nomen: e.target.value}); }}
                                style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}} />
                        </div>
                        <div style={{flex: isMobile ? '0 0 100%' : 1, minWidth: '120px'}}>
                            <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Compte</label>
                            <input type="text" placeholder="Filtrer par compte..." defaultValue={filterCompte}
                                onBlur={(e) => { setFilterCompte(e.target.value); if (e.target.value === filterCompte) return; getNomenclature({compte: e.target.value}); }}
                                style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}} />
                        </div>
                        </div>
                        <div style={{display: 'flex', flexWrap: 'wrap', gap: 15}}>
                        <div style={{flex: isMobile ? '0 0 100%' : 2, minWidth: '150px'}}>
                            <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Nom</label>
                            <input type="text" placeholder="Filtrer par nom..." defaultValue={filterNom}
                                onBlur={(e) => { setFilterNom(e.target.value); if (e.target.value === filterNom) return; getNomenclature({nom: e.target.value}); }}
                                style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}} />
                        </div>
                        <div style={{flex: isMobile ? '0 0 100%' : '0 0 160px', minWidth: '140px'}}>
                            <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Rang</label>
                            <div style={{display: 'flex', gap: 4}}>
                                <select value={filterRangOp} onChange={(e) => setFilterRangOp(e.target.value)}
                                    style={{padding: '8px 4px', borderRadius: '4px', border: '1px solid #ddd', flexShrink: 0}}>
                                    <option value="eq">=</option>
                                    <option value="gt">&gt;</option>
                                    <option value="gte">&gt;=</option>
                                    <option value="lt">&lt;</option>
                                </select>
                                <input type="number" placeholder="Ex: 0" defaultValue={filterRang}
                                    onBlur={(e) => { setFilterRang(e.target.value); }}
                                    style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}} />
                            </div>
                        </div>
                        <div style={{flex: isMobile ? '0 0 100%' : '0 0 120px', minWidth: '100px'}}>
                            <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Fct/Inv</label>
                            <select value={filterFctinv} onChange={(e) => { setFilterFctinv(e.target.value); getNomenclature({fctinv: e.target.value}); }}
                                style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}}>
                                <option value="">Tous</option>
                                <option value="FCT">FCT</option>
                                <option value="INV">INV</option>
                            </select>
                        </div>
                        <div style={{flex: isMobile ? '0 0 100%' : '0 0 120px', minWidth: '100px'}}>
                            <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '12px'}}>Rec/Dep</label>
                            <select value={filterRecdep} onChange={(e) => { setFilterRecdep(e.target.value); getNomenclature({recdep: e.target.value}); }}
                                style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}}>
                                <option value="">Tous</option>
                                <option value="R">R</option>
                                <option value="D">D</option>
                                <option value="RD">RD</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            {/* Compteur résultats */}
            <div style={{margin: isMobile ? 10 : 50, padding: 15, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${blue}`, marginBottom: 20}}>
                <p style={{margin: 0, fontWeight: 'bold', color: '#333', fontSize: isMobile ? '12px' : '14px'}}>
                    {getListeFiltered().length} résultat{getListeFiltered().length > 1 ? 's' : ''} trouvé{getListeFiltered().length > 1 ? 's' : ''}
                    {liste.length === 500 && <span style={{color: '#888', marginLeft: 10, fontWeight: 'normal'}}>(limité à 500 — utilisez les filtres pour affiner)</span>}
                </p>
            </div>

            {/* Tableau */}
            <div className='shadow-md rounded-md' style={{margin: isMobile ? 10 : 50}}>
                {isLoading ? (
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px'}}>
                        <div style={{textAlign: 'center'}}>
                            <div style={{border: '4px solid #f3f3f3', borderTop: '4px solid ' + purple, borderRadius: '50%', width: '50px', height: '50px', animation: 'spin 1s linear infinite', margin: '0 auto 20px'}}></div>
                            <p style={{color: purple, fontWeight: 'bold'}}>Chargement de la nomenclature...</p>
                        </div>
                        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } } div::-webkit-scrollbar { display: none; }`}</style>
                    </div>
                ) : (
                    <>
                    <div style={{overflowX: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none'}}>
                        <div style={{display: 'flex', backgroundColor: blue, borderTopLeftRadius: 5, borderTopRightRadius: 5, color: 'white', flexWrap: 'nowrap', borderBottom: '3px solid ' + blue, minWidth: isMobile ? 600 : 'auto'}}>

                            <button onClick={() => sortBy('id', boolID, setBoolID)} style={headerBtnStyle(0.05, '50px')}>
                                <p style={{margin: 0}}>ID</p>
                            </button>
                            <button onClick={() => sortBy('rang', boolRang, setBoolRang)} style={headerBtnStyle(0.05, '50px')}>
                                <p style={{margin: 0}}>Rang</p>
                            </button>
                            <button onClick={() => sortBy('nomen', boolNomen, setBoolNomen)} style={headerBtnStyle(0.05, '70px')}>
                                <p style={{margin: 0}}>Nomen</p>
                            </button>
                            <button onClick={() => sortBy('annee', boolAnnee, setBoolAnnee)} style={headerBtnStyle(0.05, '65px')}>
                                <p style={{margin: 0}}>Année</p>
                            </button>
                            {!isMobile && (
                            <div style={headerBtnStyle(0.1, '120px')}>
                                <p style={{margin: 0}}>Matricule</p>
                            </div>
                            )}
                            <button onClick={() => sortBy('compte', boolCompte, setBoolCompte)} style={headerBtnStyle(0.05, '80px')}>
                                <p style={{margin: 0}}>Compte</p>
                            </button>
                            <button onClick={() => sortBy('nom', boolNom, setBoolNom)} style={headerBtnStyle(0.35, '150px')}>
                                <p style={{margin: 0}}>Nom</p>
                            </button>
                            <button onClick={() => sortBy('fctinv', boolFctinv, setBoolFctinv)} style={headerBtnStyle(0.05, '65px')}>
                                <p style={{margin: 0}}>Fct/Inv</p>
                            </button>
                            <button onClick={() => sortBy('recdep', boolRecdep, setBoolRecdep)} style={headerBtnStyle(0.05, '65px')}>
                                <p style={{margin: 0}}>Rec/Dep</p>
                            </button>
                            <button onClick={() => sortBy('old', boolOld, setBoolOld)} style={headerBtnStyle(0.05, '55px')}>
                                <p style={{margin: 0}}>Old</p>
                            </button>
                            <button onClick={() => sortBy('indentation', boolIndentation, setBoolIndentation)} style={headerBtnStyle(0.05, '70px')}>
                                <p style={{margin: 0}}>Indent.</p>
                            </button>
                            <button onClick={() => sortBy('calcul', boolCalcul, setBoolCalcul)} style={headerBtnStyle(0.1, '60px')}>
                                <p style={{margin: 0}}>Calcul</p>
                            </button>

                        </div>
                    </div>

                    <div style={{overflowY: 'auto', maxHeight: (heightObject + 100), backgroundColor: '#fafafa', overflowX: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none'}}>
                        {getListeFiltered().map((item, i) => (
                            <div key={i} style={{display: 'flex', flexWrap: 'nowrap', width: '100%', borderBottom: '1px solid #e0e0e0', backgroundColor: i % 2 === 0 ? '#ffffff' : '#f5f5f5', minWidth: isMobile ? 600 : 'auto'}}>

                                <div style={inputStyle(0.05, '50px', true)}>{item.id}</div>
                                <div style={inputStyle(0.05, '50px')}>{item.rang}</div>
                                <div style={inputStyle(0.05, '70px')}>{item.nomen}</div>
                                <div style={inputStyle(0.05, '65px')}>{item.annee}</div>
                                {!isMobile && (
                                <div style={{flex: 0.1, display: 'flex', padding: '10px 8px', alignItems: 'center', justifyContent: 'center', minHeight: '50px', minWidth: '120px', borderLeft: '1px solid #ddd', fontSize: '11px', color: '#666', wordBreak: 'break-all'}}>
                                    {item.matricule}
                                </div>
                                )}
                                <div style={inputStyle(0.05, '80px')}>{item.compte}</div>
                                <div style={{...inputStyle(0.35, '150px'), justifyContent: 'flex-start'}}>{rescueHtml(item.nom ?? '')}</div>
                                <div style={{...inputStyle(0.05, '65px'), textAlign: 'center'}}>{item.fctinv}</div>
                                <div style={{...inputStyle(0.05, '65px'), textAlign: 'center'}}>{item.recdep}</div>
                                <div style={{...inputStyle(0.05, '55px'), textAlign: 'center'}}>{item.old}</div>
                                <div style={{...inputStyle(0.05, '70px'), textAlign: 'center'}}>{item.indentation}</div>
                                <div style={{...inputStyle(0.1, '60px'), textAlign: 'center'}}>{item.calcul}</div>
                                

                            </div>
                        ))}
                    </div>
                    </>
                )}
            </div>

        </Access>

        {showImportModal && (
            <div style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                onClick={(e) => { if (e.target === e.currentTarget) { setShowImportModal(false); setImportFile(null); } }}>
                <div style={{backgroundColor: 'white', borderRadius: '8px', padding: 30, width: isMobile ? '90%' : '680px', boxShadow: '0 10px 40px rgba(0,0,0,0.3)'}}>
                    <p style={{textAlign: 'center', fontSize: 18}}>Import</p>
                    <p style={{marginTop: 15, fontSize: 16}}>Protocole pour importer une nouvelle nomenclature :</p>
                    <p style={{marginTop: 0, fontSize: 13}}>1) Télécharger la dernière année de la BDD pour la nomenclature souhaitée. (Ex: M57 2025)</p>
                    <p style={{marginTop: 5, fontSize: 13}}>2) Ensuite dans ce fichier, mettre à jour les informations nécessaires. (Remplacer 2025 par 2026, rajouter les nouveaux comptes et les changements d'intitulés puis refaire les rangs)</p>
                    <p style={{marginTop: 5, fontSize: 13}}>3) Enfin, uploadez le fichier et validez l'import.</p>

                    <div style={{marginBottom: 25, marginTop: 15}}>
                        <label style={{display: 'block', marginBottom: 5, fontWeight: 'bold', fontSize: '13px'}}>Fichier XLSX *</label>
                        <div
                            onDragOver={(e) => { e.preventDefault(); setImportDragOver(true); }}
                            onDragLeave={() => setImportDragOver(false)}
                            onDrop={(e) => { e.preventDefault(); setImportDragOver(false); const f = e.dataTransfer.files[0]; if (f) setImportFile(f); }}
                            onClick={() => document.getElementById('import-file-input').click()}
                            style={{border: `2px dashed ${importDragOver ? purple : '#ccc'}`, borderRadius: '6px', padding: '30px 20px', textAlign: 'center', cursor: 'pointer', backgroundColor: importDragOver ? '#f0efff' : '#fafafa', transition: 'all 0.2s'}}>
                            {importFile
                                ? <p style={{margin: 0, color: '#333', fontWeight: 'bold'}}>📄 {importFile.name}</p>
                                : <><p style={{margin: 0, color: '#888'}}>Glissez-déposez un fichier XLSX ici</p><p style={{margin: '6px 0 0', color: '#aaa', fontSize: '12px'}}>ou cliquez pour parcourir</p></>}
                        </div>
                        <input id="import-file-input" type="file" accept=".xlsx,.xls" style={{display: 'none'}}
                            onChange={(e) => { if (e.target.files[0]) setImportFile(e.target.files[0]); }} />
                    </div>

                    <div style={{display: 'flex', gap: 10, justifyContent: 'flex-end'}}>
                        <button onClick={() => { setShowImportModal(false); setImportFile(null); }}
                            style={{padding: '10px 20px', backgroundColor: '#ccc', color: '#333', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold'}}>
                            Annuler
                        </button>
                        <button onClick={handleImport}
                            style={{padding: '10px 20px', backgroundColor: green, color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold'}}>
                            Valider l'import
                        </button>
                    </div>
                </div>
            </div>
        )}
        </>
	);
}


export default Nomenclature;